// extracted by mini-css-extract-plugin
export default {"wrap":"OJ-z","fullWidth":"PJ-z","hideOnDesktop":"QJ-z","content":"RJ-z","hasOpenedNav":"SJ-z","crumbsList":"TJ-z","dropdownsWrap":"UJ-z"};